import { render, staticRenderFns } from "./CmgApp.vue?vue&type=template&id=0af62a3c&lang=pug"
import script from "./cmg-app.ts?vue&type=script&lang=ts&external"
export * from "./cmg-app.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgApp.vue?vue&type=style&index=0&id=0af62a3c&prod&lang=scss"
import style1 from "./CmgApp.vue?vue&type=style&index=1&id=0af62a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports